import { ReactComponent as BackArrow } from '@basqet-dashboard/common/assets/icons/back-arrow.svg';
import PropTypes from 'prop-types';
import React from 'react';

const BackButton = ({ onClick }) => {
  return (
    <button className="payout__back-btn" onClick={onClick}>
      <BackArrow />
    </button>
  );
};

BackButton.propTypes = {
  onClick: PropTypes.func
};

export { BackButton };
